module.exports = __webpack_public_path__ + "static/deneir-symbol-DND3_FnP-b101676aa76c9655238c81aa2925a570.jpg";